<template>
  <AppLoaderVue v-if="!ready"></AppLoaderVue>
  <router-view v-else></router-view>
</template>

<script>
import AppLoaderVue from './components/core/AppLoader.vue';

export default {
  name: "App",
  components: {
    AppLoaderVue,
  },
  created() {
    window.app.vm = this;
  },
  computed: {
    ready() {
      return this.$store.getters.ready;
    }
  },
};
</script>

<style lang="scss">
@import '@/assets/sass/_responsiveness.scss';

html,
body {
  height: 100vh;
  max-width: 100vw;
  scroll-behavior: smooth;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

img, button, a {
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -o-user-select: none;
  user-select: none;

  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  user-drag: none;
}


// Global Styling 


// Scrollbar
* {
  scrollbar-color: var(--dark-grey) var(--light-grey);
  scrollbar-width: thin;

  & *::-webkit-scrollbar {
    width: 8px;
  }

  & *::-webkit-scrollbar-track {
    background: var(--light-grey);
  }

  & *::-webkit-scrollbar-thumb {
    background: var(--dark-grey);
    height: 50%;
  }
  
}

// General <section> styling
.ContentSection {
  position: relative;

  h1 {
    font-size: 57px;
    font-weight: 700;
    width: 100%;
    max-width: var(--content-max-width);
    padding: var(--content-padding);

    @include tablet-down {
      font-size: 38px;
    }

    @include mobile-only{
      font-size: 33px;
    }
  }


  h2 {
    font-size: 44px;
    font-weight: 700;
    width: 100%;
    max-width: var(--content-max-width);
    padding: var(--content-padding);

    @include tablet-down {
      font-size: 38px;
    }
    @include mobile-only{
      font-size: 33px;
    }
  }

  h3 {
    font-size: 40px;
    width: 100%;
    max-width: var(--content-max-width);
    padding: var(--content-padding);

    @include tablet-down {
      font-size: 38px;
    }
    @include mobile-only{
      font-size: 30px;
    }
  }

  h4 {
    font-size: 32px;
    font-weight: 700;
    width: 100%;
    max-width: var(--content-max-width);
    padding: var(--content-padding);
  }

  h5 {
    font-size: 26px;
    font-weight: 700;
    width: 100%;
    max-width: var(--content-max-width);
    padding: var(--content-padding);
  }

  h6 {
    font-size: 16px;
    line-height: 22px;
    width: 100%;
    max-width: var(--content-max-width);
    padding: var(--content-padding);
  }

  p {
    width: 100%;
    max-width: var(--content-max-width);
    padding: var(--content-padding);
    font-size: 16px;
    line-height: 22px;

    >a {
      display: inline;
      color: var(--secondary-color)
    }
  }

  &.ContentSection--hasclippath {
    &::after {
      position: absolute;
      content: '';
      background-color: inherit;
      clip-path: var(--section-clippath);
      height: 40px;
      width: 100%;
      min-width: 1920px;
      top: 100%;
      margin-top: -1px;
      z-index: 2;
    }
  }
}

a {
  cursor: pointer;

  &.Button {
    min-width: 185px;
    width: fit-content;
    padding: 0 20px;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-transform: uppercase;
    border-radius: 10000px;
    font-size: 22px;
    font-weight: 700;
    transition: transform 0.1s ease;
    backface-visibility: hidden;

    @include mobile-only{
      width: initial;
 
    }

    &:hover {
      transform: scale(1.03);
    }
  }

  &.hyperLink {
    position: relative;
    font-size: 18px;
    font-weight: 700;
    text-align: left;
    width: 100%;
    max-width: var(--content-max-width);
    padding: var(--content-padding);
    color:#FFAF37;

    >div {
      display: inline-block;
      width: 20px;

      >svg, >img {
        transition: var(--tk-easeinout) 0.2s transform;
        transform: translateY(15%);
      }
    }

    &:hover {
      >div {
        >svg, >img {
          transform: translateY(15%) translateX(5px);
        }
      }
    }
  }
}

strong {
  font-weight: bold;
}

em {
  font-style: italic;
}

// PDF ELEMENT HIDER


.wide{
  width:1000px;
}


// ANIMATIONS
// Transition Fade
.fadeOut-enter-active,
.fadeOut-leave-active {
    transition-timing-function: ease;
    transition-duration: 0.25s;
    transition-property: opacity;
}

// RIGHT
.fadeOut-enter-from {
    opacity: 0;
}
.fadeOut-leave-to {
    opacity: 0;
}

// TRANSITION LEFT AND RIGHT
.fadeOutRight-enter-active,
.fadeOutRight-leave-active,
.fadeOutLeft-enter-active,
.fadeOutLeft-leave-active {
    transition-timing-function: cubic-bezier(.3, .62, .39, .99);
    transition-duration: 0.3s;
    transition-property: transform, opacity;
}

// RIGHT
.fadeOutRight-enter-from {
    opacity: 0;
    transform: translateX(-80px);
}
.fadeOutRight-leave-to {
    transform: translateX(80px);
    opacity: 0;
}

// LEFT
.fadeOutLeft-enter-from {
    opacity: 0;
    transform: translateX(80px);
}

.fadeOutLeft-leave-to {
    transform: translateX(-80px);
    opacity: 0;
}


//TRANSITION FADEOUT UP
.fadeOutUp-enter-active,
.fadeOutUp-leave-active {
    transition-timing-function: cubic-bezier(.3, .62, .39, .99);
    transition-duration: 0.3s;
    transition-property: transform, opacity;
}

.fadeOutUp-enter-from {
    opacity: 0;
    transform: translateY(20px);
}
.fadeOutUp-leave-to {
    transform: translateY(-20px);
    opacity: 0;
}

//TRANSITION FADEOUT DOWN
.fadeOutDown-enter-active,
.fadeOutDown-leave-active {
    transition-timing-function: cubic-bezier(.3, .62, .39, .99);
    transition-duration: 0.3s;
    transition-property: transform, opacity;
}

.fadeOutDown-enter-from {
    opacity: 0;
    transform: translateY(-20px);
}
.fadeOutDown-leave-to {
    transform: translateY(20px);
    opacity: 0;
}

// FADE IN
.fade-in-enter-active {
  transition: opacity 0.2s ease-out;
}
.fade-in-leave-active {
  transition: opacity 0.05s ease-out;
}

.fade-in-enter-from,
.fade-in-leave-to {
  opacity: 0;
}

</style>